export const StudioServices = [
  {
    icon: "/images/studio/branding.svg",
    name: "Branding",
    description:
      "We craft brands that tell stories, spark emotion, and leave a lasting impression. From strategy and visual identity to tone and positioning, shaping how people see and feel your brand. Turning vision into a brand people remember.",
  },
  {
    icon: "/images/studio/ui-ux.svg",
    name: "UI/UX Designing",
    description:
      "We design intuitive experiences that feel effortless and engaging. From wireframes to polished interfaces, every detail is crafted with purpose and precision. Shaping every interaction to be seamless, beautiful, and meaningful.",
  },
  {
    icon: "/images/studio/softwareDev.svg",
    name: "Software Development",
    description:
      "We build robust, scalable software tailored to your goals and growth. Turning ideas and challenges into powerful digital products. We blend clean code and smart architecture with seamless performance.",
  },
  {
    icon: "/images/studio/digitalMarket.svg",
    name: "Digital Marketing",
    description:
      "We create digital strategies that connect brands with the right audience and drive real results. From social campaigns to SEO and performance marketing, every move is data driven and purposeful. Turning engagement into growth and visibility into lasting impact.",
  },
];
